const variantClasses = {
  primary:
    "bg-primary text-white hover:bg-primary-hover dark:bg-primary-dark dark:hover:bg-primary",
  accent:
    "bg-accent text-primary hover:bg-accent-hover hover:text-white dark:bg-accent-dark dark:hover:bg-accent",
  secondary:
    "border border-border bg-white text-primary hover:border-primary hover:bg-bg-subtle dark:border-border-dark dark:bg-bg-subtle-dark dark:text-text-dark dark:hover:border-accent",
  ghost:
    "text-primary hover:bg-bg-subtle dark:text-text-dark dark:hover:bg-bg-subtle-dark",
};

export function Button({ label, variant = "primary", href, type = "button", className = "", attrs = "" } = {}) {
  const classes = [
    "inline-flex items-center justify-center rounded px-5 py-3 text-sm font-semibold transition focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 dark:focus:ring-offset-bg-dark",
    variantClasses[variant] || variantClasses.primary,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (href) {
    return `<a href="${href}" data-link class="${classes}" ${attrs}>${label}</a>`;
  }

  return `<button type="${type}" class="${classes}" ${attrs}>${label}</button>`;
}
